<template>
  <v-app>
    <v-main class="grey lighten-4" style="background-color: #f5f5f5;">
      <v-container class="d-flex align-center justify-center" style="min-height: 100vh; padding: 24px 16px;">
        <portal-busca-form style="width: 100%;" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import PortalBuscaForm from '@/components/portal/PortalBuscaForm.vue'

export default {
  name: 'PortalBusca',
  components: { PortalBuscaForm },
}
</script>
